import Swiper from 'swiper/bundle';

import 'swiper/css';
import 'swiper/css/pagination';

export default class Banner {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const swipercont = document.querySelector('.js-banner');

        if(!swipercont) return;

        const pagenation = document.querySelector('.js-banner-pagination');
        const slides = [...swipercont.querySelectorAll('.swiper-slide')];

        if (slides.length >= 2) {
            swipercont.classList.add('-slideover');
        } else {
            swipercont.classList.add('-slideone');
        }

        const option = {
            autoplay: slides.length > 1 ? { delay: 5000, disableOnInteraction: false } : false,
            spaceBetween: 20,
            loop: true,
            slidesPerView: slides.length >= 2 ? 2 : 1,
            speed: 700,
            pagination: { el: pagenation, clickable: true },
        };

        const swiper = new Swiper(swipercont, option);
    }
}